import React, { Component } from 'react'
import '../login/loading-cp.css'

class LoadingIndicator extends Component {
  constructor() {
    super();
    // this.state = {}
  }

  render() {
    return (
      <div className='loading-contain'>
        <img src='/img/loading.gif' />
      </div>
    )
  }
}

export default LoadingIndicator
